import React, { useEffect } from 'react'
import ProfileNav from '../component/ProfileNav'
import BasicInfo from '../component/BasicInfo'
import CreditManager from '../component/CreditManager'
import ApplicationStatus from '../component/ApplicationStatus'
import { Button } from '@mui/material';
import LibraryAddCheckIcon from '@mui/icons-material/LibraryAddCheck';
import { Link, useNavigate } from 'react-router-dom'
import HistoryIcon from '@mui/icons-material/History';
import "../profile.css";
import { useSelector, useDispatch } from 'react-redux';
import { updateCustomerDetails, updateJourneyEvents, customerDetailsApiCall } from '../../CustomerJourneyDetails/CustomerJourneyDetails';
import { getCustomerDetails } from '../../Utils/api'
import RepaymentCard from '../component/RepaymentCard'
import MobileNav from '../component/MobileNav'

export default function UserDashaboard() {
  const { loan_quote, personal_details, upload_documents } = useSelector((state) => state?.customerJourneyDetails?.journeySteps);
  const journeyComplete = useSelector((state)=>state?.customerJourneyDetails?.customerDetails?.journeyCompletedFlag)
  const navigate = useNavigate();
  const customerStep = useSelector((state) => state?.customerJourneyDetails?.journeySteps);
    const customerDetails = useSelector((state) => state?.customerJourneyDetails?.customerDetails);
    const dispatch = useDispatch();
  
    const params = {
      profileId: customerDetails?.profileId,
    };
  
    
  
    async function fetchCustomerDetails() {
      if (params.profileId) {
       const response = await getCustomerDetails(params);;
        if (response?.data?.apiStatus == 1) {
          dispatch(updateCustomerDetails(response?.data?.data?.customer_details));
          dispatch(updateJourneyEvents(response?.data?.data?.screen_details));
  
        }
      }
    }
  
  
  
    useEffect(() => {
      fetchCustomerDetails();
   
    }, [customerStep?.check_eligibility]);

  const handlejourney = () => {
    navigate('/journey')
  }

  // Check if all journey steps are 1
  const allStepsCompleted = loan_quote === 1 && personal_details === 1 && upload_documents === 1;

  return (
    <>
      <div className='container mt-5' style={{ display: 'flex' }}>
        <div className='left-box pt-5'>
          <ProfileNav />
        </div>
        <div className='right-box'>
          <div className='panel'>
            {/* Conditionally render the Continue to Apply button */}
            {(!allStepsCompleted ||  journeyComplete == 0) && (
              <div className='mb-3 d-flex justify-content-end'>
                <Button
                  variant='contained'
                  className='text-upper ms-bg-secondary fs-6 fw-semibold'
                  size='small'                  
                  onClick={handlejourney}
                >
                  <LibraryAddCheckIcon /> &nbsp; Continue to Apply
                </Button>
              </div>
            )}

            <BasicInfo />
            <div className='row'>
              <div className='col-lg-6 mt-4'>
                <h5 className='text-uppercase fw-semibold pb-2'>Credit Manager</h5>
                <CreditManager />
              </div>
              <div className='col-lg-6 mt-4'>
                <h5 className='text-uppercase fw-semibold pb-2'>Application Status</h5>
                <ApplicationStatus />
              </div>
            </div>
            <Button variant="outlined" className='icon-color-primary mt-4' style={{background:'#9a141a', color:'#fff'}} startIcon={<HistoryIcon />}>
             <Link to='/journey/loan-history' className='text-decoration-none icon-color-primary text-white fw-bold'  > Loan History </Link>
            </Button>

            {/* <RepaymentCard/> */}



          </div>
        </div>
      </div>
      <MobileNav/>
      
    </>
  )
}
